/*
 * Stardust barrel roll for the Tinsella headings ("Meet Tinsella", "Let Tinsella find the perfect gift").
 * A spark corkscrews along each line of the heading, trailing stardust, and as it passes the word
 * Tinsella the word wipes to red. Decorative only; plays once when the heading scrolls into view and
 * again if the heading is hovered. Visitors who prefer reduced motion just get the red word.
 */
(function () {
  'use strict';

  var RED = '#FF2B3D';
  var COLOURS = ['#F0CB6B', '#F6EFDD', '#C9B8FF', '#FFFFFF'];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function wrapWord(el, word) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var at = node.nodeValue.indexOf(word);
      if (at === -1) continue;
      var hit = at > 0 ? node.splitText(at) : node;
      if (hit.nodeValue.length > word.length) hit.splitText(word.length);
      var span = document.createElement('span');
      span.className = 'tp-roll-word';
      hit.parentNode.insertBefore(span, hit);
      span.appendChild(hit);
      return span;
    }
    return null;
  }

  // One box per line of text: { l, r, cy, h }
  function measureLines(el) {
    var rects = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var range = document.createRange();
      range.selectNodeContents(node);
      Array.prototype.forEach.call(range.getClientRects(), function (r) {
        if (r.width > 1 && r.height > 1) rects.push(r);
      });
    }
    var lines = [];
    rects.forEach(function (r) {
      var cy = (r.top + r.bottom) / 2;
      var line = null;
      lines.forEach(function (l) { if (Math.abs(l.cy - cy) < r.height * 0.5) line = l; });
      if (!line) { line = { l: r.left, r: r.right, cy: cy, h: r.height }; lines.push(line); }
      else { line.l = Math.min(line.l, r.left); line.r = Math.max(line.r, r.right); }
    });
    lines.sort(function (a, b) { return a.cy - b.cy; });
    return lines;
  }

  function setup(el) {
    if (el.__tpRoll) return;
    var state = el.__tpRoll = { el: el, running: false, last: 0, word: null };
    var word = el.getAttribute('data-tp-roll-word');
    if (word) state.word = wrapWord(el, word);
    if (state.word) state.word.style.setProperty('--tp-wipe', '0');
    if (reduce.matches) {
      if (state.word) state.word.style.setProperty('--tp-wipe', '1');
      return;
    }
    observer.observe(el);
    el.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      if (!state.running && performance.now() - state.last > 6000) play(state);
    });
  }

  function play(state) {
    if (state.running || reduce.matches) return;
    var el = state.el;
    var lines = measureLines(el);
    if (!lines.length) return;
    state.running = true;

    var box = el.getBoundingClientRect();
    var padX = 60, padY = 60;
    var padL = Math.min(padX, Math.max(0, box.left));
    var padR = Math.min(padX, Math.max(0, window.innerWidth - box.right));
    var w = box.width + padL + padR;
    var h = box.height + padY * 2;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var canvas = document.createElement('canvas');
    canvas.className = 'tp-roll-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    canvas.style.cssText = 'left:' + (-padL) + 'px;top:' + (-padY) + 'px;width:' + w + 'px;height:' + h + 'px';
    el.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    // Where the word sits, so the wipe follows the spark across it
    var wordBox = null, wordLine = -1;
    if (state.word) {
      wordBox = state.word.getBoundingClientRect();
      var wcy = (wordBox.top + wordBox.bottom) / 2;
      lines.forEach(function (l, i) { if (Math.abs(l.cy - wcy) < l.h * 0.5) wordLine = i; });
      state.word.style.setProperty('--tp-wipe', '0');
    }

    var LEAD = 40, SPEED = 250, GAP = 0.3, WAVE = 120, TILT = Math.PI / 4;
    var segs = lines.map(function (l) { return { l: l.l, len: (l.r - l.l) + LEAD * 2 }; });
    var total = segs.reduce(function (sum, s) { return sum + s.len / SPEED + GAP; }, 0);

    var parts = [], trail = [];
    var t0 = performance.now(), prev = t0;

    function star(x, y, r, colour, alpha) {
      ctx.globalAlpha = alpha;
      ctx.fillStyle = colour;
      ctx.beginPath();
      ctx.moveTo(x, y - r); ctx.lineTo(x + r * 0.26, y - r * 0.26); ctx.lineTo(x + r, y);
      ctx.lineTo(x + r * 0.26, y + r * 0.26); ctx.lineTo(x, y + r); ctx.lineTo(x - r * 0.26, y + r * 0.26);
      ctx.lineTo(x - r, y); ctx.lineTo(x - r * 0.26, y - r * 0.26); ctx.closePath();
      ctx.fill();
    }

    function finish() {
      if (state.word) state.word.style.setProperty('--tp-wipe', '1');
      if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      state.running = false;
      state.last = performance.now();
    }

    function frame(now) {
      var dt = Math.min((now - prev) / 1000, 0.05);
      prev = now;
      var el_t = (now - t0) / 1000;
      ctx.clearRect(0, 0, w, h);

      // Which line the spark is on, and how far along it
      var rest = el_t, idx = -1, along = 0, travelling = false;
      for (var i = 0; i < segs.length; i++) {
        var dur = segs[i].len / SPEED;
        if (rest < dur) { idx = i; along = rest * SPEED; travelling = true; break; }
        rest -= dur;
        if (rest < GAP) { idx = i; along = segs[i].len; break; }
        rest -= GAP;
      }

      if (idx === -1) {
        if (!parts.length || el_t > total + 1) { finish(); return; }
      } else if (travelling) {
        var line = lines[idx];
        var x = segs[idx].l - LEAD + along;
        // One spark circling the line on a ring tilted 45 degrees: it swings forward and back
        // as the ring itself moves along the text, so it loops like a corkscrew
        var phase = ((x - segs[idx].l) / WAVE) * Math.PI * 2;
        var rx = line.h * 0.72, ry = line.h * 0.42;
        var ox = rx * Math.cos(phase), oy = ry * Math.sin(phase);
        var hx = x + (ox * Math.cos(TILT) - oy * Math.sin(TILT));
        var hy = line.cy + (ox * Math.sin(TILT) + oy * Math.cos(TILT));
        var depth = Math.sin(phase);                    // near side of the ring is bigger and brighter
        var px = hx - box.left + padL, py = hy - box.top + padY;
        trail.push({ x: px, y: py, d: depth });
        if (trail.length > 42) trail.shift();
        for (var n = 0; n < 7; n++) {
          parts.push({
            x: px, y: py,
            vx: (Math.random() - 0.5) * 70 - 10, vy: (Math.random() - 0.5) * 70,
            spin: (Math.random() < 0.5 ? -1 : 1) * (2.5 + Math.random() * 4),   // radians a second the dust curls by
            life: 0, max: 0.9 + Math.random() * 0.9, size: 1.3 + Math.random() * 2.6,
            colour: COLOURS[Math.floor(Math.random() * COLOURS.length)]
          });
        }
        if (state.word && wordBox) {
          var wipe = idx > wordLine ? 1 : (idx === wordLine ? (x - wordBox.left) / wordBox.width : 0);
          state.word.style.setProperty('--tp-wipe', String(Math.max(0, Math.min(1, wipe)).toFixed(3)));
        }
      } else {
        trail.length = 0;
      }

      // Ribbon behind the spark
      for (var k = 1; k < trail.length; k++) {
        var ra = trail[k - 1], rb = trail[k], f = k / trail.length;
        ctx.globalAlpha = f * 0.55;
        ctx.strokeStyle = '#F0CB6B';
        ctx.lineWidth = 0.8 + f * (1.5 + rb.d);
        ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(ra.x, ra.y); ctx.lineTo(rb.x, rb.y); ctx.stroke();
      }

      // Stardust
      for (var j = parts.length - 1; j >= 0; j--) {
        var p = parts[j];
        p.life += dt;
        if (p.life >= p.max) { parts.splice(j, 1); continue; }
        // Curl the velocity round so each speck spirals away instead of drifting straight
        var ang = p.spin * dt, cs = Math.cos(ang), sn = Math.sin(ang), nvx = p.vx * cs - p.vy * sn;
        p.vy = p.vx * sn + p.vy * cs; p.vx = nvx;
        p.x += p.vx * dt; p.y += p.vy * dt + 6 * dt;
        var fade = 1 - p.life / p.max;
        star(p.x, p.y, p.size * (0.6 + fade * 0.6), p.colour, fade * (0.55 + 0.45 * Math.sin(p.life * 28) * Math.sin(p.life * 28)));
      }

      // Bright head
      if (travelling && trail.length) {
        var hd = trail[trail.length - 1];
        ctx.shadowColor = '#F0CB6B';
        ctx.shadowBlur = 14;
        star(hd.x, hd.y, 6.5 + hd.d * 3, '#FFFFFF', 0.75 + 0.25 * hd.d);
        ctx.shadowBlur = 0;
      }
      ctx.globalAlpha = 1;
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(function (now) { t0 = prev = now; frame(now); });
  }

  function init(scope) {
    if (!observer) {
      observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          var state = entry.target.__tpRoll;
          // Let the heading's own drift-in finish first
          if (state) window.setTimeout(function () { play(state); }, 450);
        });
      }, { threshold: 0.7 }) : { observe: function () {}, unobserve: function () {} };
    }
    (scope || document).querySelectorAll('[data-tp-roll]').forEach(setup);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
